module.exports = function anonymous(it
) {
var out='<div style="font-size: 18px;margin-bottom: 10px;line-height: 25px;text-align: center;" class="js-finished-label label label-success offset4 span4"> <i class="icon icon-ok"></i> <span rel="localize[import-finished]">Finished</span</div>';return out;
}